import { z } from "zod";
import { REGEX } from "../../../../../constants";

export const moreAboutCompanySchema = z.object({
  company: z.string().min(1, "Company Name is required"),
  title: z.string().min(1, "Title is required"),
  linkedIn: z
    .string()
    .min(1, "LinkedIn URL is required")
    .refine(
      (val) => !val || REGEX.URL.test(val),
      "LinkedIn URL is not valid"
    ),
  no_of_emp: z.string().min(1, "Number of Employees is required"),
});

export type MoreAboutCompanyFormData = z.infer<typeof moreAboutCompanySchema>;

export const defaultValues: MoreAboutCompanyFormData = {
  company: "",
  title: "",
  linkedIn: "",
  no_of_emp: "",
};

export const PAGE_CONFIG = {
  TITLE: "Tell us about your company",
} as const;
